module.exports = __webpack_public_path__ + "img/bell_concierge.80f05f89.svg";